export const EMPTY_ENV_VARIABLES: Record<string, string> = {};
